export default {
  LandingPage: {
    intro_sub:
      'Give a second life to package waste and participate in protecting the environment',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Join us in reducing the waste',
    sequence1_2:
      'for sustainable environment by recreating your product packaging into useful items. Scroll down to make your first step',
    sequence2_1: 'Introducing Samsung Upcycle-Packaging',
    sequence2_2:
      'A box specially designed to be upcycled for your contribution to the environment. Make various household items with your product packaging',
    sequence3_1: 'Follow printed dots on the packaging',
    sequence3_2:
      'Cut out the packaging as it is instructed and assemble to create an amazing item.',
    sequence4_1: 'Select the item that you want to make',
    sequence4_2:
      'Scroll down and select the product model that you have on your packaging. Then find various design options for you. Now, begin your journey with the item you desire to create',
    selectBox: 'Select Your product',
    moreActivity:
      "For more information about <br class='desktop'/> sustainable activities in Samsung",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/us/sustainability/overview/',
    moreActivityLink:'https://www.samsung.com/us/aboutsamsung/sustainability/strategy/',

    footer: `
    copyright© 2019-2021 SAMSUNG All Rights Reserved.`,
  },
  ProductPage: {
    selectDesign: 'Select design to create',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Soccer', 
    tvConsole: 'TV Console',
    StorageBox: 'Storage Box',
    MagazineRack: 'Magazine Rack',
    CatHouse: 'Cat House',
    CatTunnel: 'Cat Tunnel',
    BookShelf: 'Bookshelf',
    DeskShelf: 'Desk Shelf',
    BlackRhino: 'Endangered \n Animals \n Black Rhino', //update
    PolarBear: 'Endangered \n Animals \n Polar Bear', //update
    SeaTurtle: 'Endangered \n Animals \n Sea Turtle', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko table', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postcard \n Planter', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Tool Box', //update
    DeskStationary: 'Stationery',
    CoinBank: 'Coin Bank',
    MobileScanner:'Smartphone scanner Stand',
    TabletScanner:'Tablet scanner Stand',
    PetStairs:'Pet Stairs',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'mins',
    all:'ALL',
    in: 'in',
    inOnly: 'in Only',
    allBoxSize: 'All box sizes',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'Instructions',
    prepare: 'Prepare the box',
    LetsDesign: "Let's Design",
    drawParts: 'Draw parts on the box',
    note1: 'Note that the graphic position may vary by countries and sizes',
    note2: 'Sketch the entire drawing first so that it fits in the box',
    numberSpace: 'number = spaces between dots',
    diagonal: 'diagonal',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    TOP: 'TOP',
    TOP1: 'TOP 1',
    TOP2: 'TOP 2',
    BACK: 'BACK',
    MIDDLE: 'MIDDLE',
    MIDDLE2: 'MIDDLE 2',
    BOTTOM: 'BOTTOM',
    FRONT: 'FRONT',
    SIDE: 'SIDE',
    secondSIDE: 'SECOND SIDE',
    secondSIDE1: 'SECOND SIDE 1',
    secondSIDE2: 'SECOND SIDE 2',
    LEG: 'LEG', //update
    JOINT: 'JOINT', //update
    FACE: 'FACE', //update
    DRAWERBOTTOM: 'DRAWER BOTTOM', //update
    DRAWERSIDE: 'DRAWER SIDE', //update
    NOSE: 'NOSE', //update
    HANDLE: 'HANDLE', //update
    BOTTOMSIDE: 'BOTTOM SIDE', //update
    TOPSIDE: 'TOP SIDE', //update
    WING: 'WING', //update
    cutAndAssemble: "Let's Cut & Assemble",
    beCareful: 'Be careful not to hurt yourself when using the cutter',
    cutOutParts: 'Cut out parts',
    assemble: 'Assemble',
    Assemblyguide: 'Assembly guide', //update
    fold: 'Folding example',
    foldGuide: 'Use the edge of furniture when folding the cardboard',
    foldGuideDezeen:
      'Press the dotted line on the cardboard with creasing tools a few times, to help the cardboard to fold', //update
    glue: 'Apply glue or tape evenly on the surface', //update
    cable: 'Use cable ties or strings to connect', //update
    done: 'Done!',
    goBack: 'Go back to main menu',
  },
  CautionPage: {
    CAUTION: 'CAUTION',
    needItem: 'You will need these items',
    children: 'Children should be with adults',
    mat:
      'Please put a cover on the ground to prevent any scratches from the process',
    doNotPutHeavyThing:
      'Do not step or sit on these furnitures and try Not to put heavy things on them',
    doNotThrow:
      'Do not throw or kick furnitures toward anything include people and animals',
    stayAwayFlame: 'Stay away from flames',
    stayAwayWater: 'Do not get close to water or humidity',
    mayDamaged: '* The TV box may be damaged during the shipping process',
    companyDoestResponsible:
      '* The company doesn’t have any responsability to breakdowns or injuries during this work',
    cannotBeReturned:
      '* The product with damaged boxes cannot be returned for non-quality issues',
    understand: 'Okay, I understood',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'We have used less paper and ink for majority of our TV packaging as compared to our previous packaging to step up our commitment to sustainability',
      text2:'',
      text2_special:
        '(* The above does not apply to certain models including Lifestyle TVs)',
      text3: 'Select buttons below to discover more',
    },
    greenIn: {
      title: 'Going Green in TV Packaging',
      subtitle1: 'Search for Product Information',
      subtitle2: 'Upcycling Eco-Package',
      desc: 'Search model name to get more information',
      descM: '*Take a photo of the TV model number',
      guide: 'model name',
      button: 'Take Photo',
      button2: 'Go To make items',
      product_info: 'Product Info',
    },
    search: {
      guide: 'Search..',
      noResult: 'No Result',
      more: 'MORE',
      search: 'Search',
      retake: 'Retake',
      result: 'Result',
    },
    photo: {
      guide1: 'Place TV model name in the box',
      guide2: '(e.g. Q800A, UT7000, RU7100, etc)',
    },
  },
  searchCountrySelect: 'Select a country to search'
};
